import { render, staticRenderFns } from "./polCollectionUsdt.vue?vue&type=template&id=f6bb43be&scoped=true"
import script from "./polCollectionUsdt.vue?vue&type=script&lang=js"
export * from "./polCollectionUsdt.vue?vue&type=script&lang=js"
import style0 from "./polCollectionUsdt.vue?vue&type=style&index=0&id=f6bb43be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bb43be",
  null
  
)

export default component.exports